import { useSelector } from "react-redux";
import "./Overview.css";

const Overview = () => {
  const movie = useSelector(state => state.movie.selectedMovie);
  return movie.map(film => (
    <div className="container">
      <div className="overview-wrapper">
        <div className="sinopsis">
          <div className="title">Synopsis</div>
          <div className="content">{film.overview}</div>
        </div>
        <div className="movie-info">
          <div className="title">Movie Info</div>
          <div className="content">
            <div>
              <span className="bold">Release Date : </span>
              {film.release_date && film.release_date.slice(0, 10)}
            </div>
            <div>
              <span className="bold">Rating : </span>
              {film.rating}
            </div>
            <div>
              <span className="bold">Popularity : </span>
              {film.popularity}
            </div>
            <div>
              <span className="bold">genres : </span>
              {film.genres.map(genre => "#" + genre)}
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
};

export default Overview;
